module.exports = __webpack_public_path__ + "static/media/alert-light-red.05135cdc.svg";